import styled from 'styled-components';
export const TypeInputContainer = styled.div`
    width: fit-content;
    border: 1px solid rgb(229 229 229);
    display: flex;
    align-items: center;
    border-radius: 5px;
`;
export const DateTypeButton = styled.input`
    cursor: pointer;
    background-color: rgb(255 255 255);
    font-style: noto_sans_kr_medium;
    border: 0px;
    padding-inline: 12px;
    padding-block: 4px;
    font-weight: ${(props) => (props.$isSelected ? 'bold' : 'normal')};
`;
export const ButtonWrapper = styled.div`
    width: 100%;
    display: flex;
    gap: 8px;
    flex-direction: row;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;
export const TextInputNoLineWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;
